import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../ui/Table';
import Button from '../../ui/Button';
import AutoListTableRow from './AutoListTableRow';

const AutoListTable = ({
  invoices = [],
  sorting,
  setSorting = () => {},
  handleDeleteRecurringInvoice,
  handleLoadInvoiceToForm,
  handleUpdateRecurringInvoice
}) => {
  const isSorted = (key, direction) => sorting && sorting.key === key && sorting.direction === direction;

  return (
    <div className="px-6 pb-6">
      <div className="border border-gray-100 rounded-xl overflow-hidden mb-4">
        <Table>
          <Thead className="bg-white">
            <Tr className="border-b border-gray-100 hover:bg-transparent">
              <Th>
                <div className="flex items-center gap-2">
                  Получател
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'receiverName', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('receiverName', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'receiverName', direction: 'desc' })} className={`text-[10px] ${isSorted('receiverName', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th>
                <div className="flex items-center gap-2">
                  Стойност
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'totalAmount', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('totalAmount', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'totalAmount', direction: 'desc' })} className={`text-[10px] ${isSorted('totalAmount', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th>
                <div className="flex items-center gap-2">
                  Повтаряне
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'interval', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('interval', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'interval', direction: 'desc' })} className={`text-[10px] ${isSorted('interval', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th>
                <div className="flex items-center gap-2">
                  Предстои
                  <div className="flex flex-col cursor-pointer">
                    <span onClick={() => setSorting({ key: 'nextInvoiceDate', direction: 'asc' })} className={`text-[10px] -mb-1 ${isSorted('nextInvoiceDate', 'asc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▲</span>
                    <span onClick={() => setSorting({ key: 'nextInvoiceDate', direction: 'desc' })} className={`text-[10px] ${isSorted('nextInvoiceDate', 'desc') ? 'text-tenant-hover' : 'text-gray-300 hover:text-gray-500'}`}>▼</span>
                  </div>
                </div>
              </Th>
              <Th className="text-gray-900 text-[13px] capitalize text-right">Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {invoices.length === 0 ? (
              <Tr>
                <Td colSpan={5} className="text-center text-gray-500 py-8">Няма намерени автоматични фактури</Td>
              </Tr>
            ) : (
              invoices.map((inv) => (
                <AutoListTableRow 
                  key={inv.id}
                  inv={inv}
                  handleLoadInvoiceToForm={handleLoadInvoiceToForm}
                  handleUpdateRecurringInvoice={handleUpdateRecurringInvoice}
                  handleDeleteRecurringInvoice={handleDeleteRecurringInvoice}
                />
              ))
            )}
          </Tbody>
        </Table>
      </div>
    </div>
  );
};

export default AutoListTable;
